export default "__VITE_ASSET__BrXB_Ci___"